<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'checkOut'"></app-head>
  </header>
  <!-- end header  -->

  <div class="row m-0">
    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'checkOut'"></app-sidebar>
    <!-- end sidebar  -->
    <!-- start content page  -->
    <main class="p-4 col-lg-10">
      <div class="d-md-flex justify-content-between" style="margin-bottom:20px">
        <div class="d-flex" style="align-items: center;">
            <p class="fw-bold me-2" style="color: #6c6a6a;margin-bottom: 0px;"><a  style="color: #6c6a6a;"class="removeUnderLine" routerLink="/inquiries">Inquiries </a></p>

            <p class="fw-bold me-2" style="margin-bottom: 0px; color: #605D62;"> > </p>
            <p class="fw-bold" style="color: #6c6a6a;margin-bottom: 0px;"routerLink="/checkout-inquire"> Checkout  </p>
            <p class="fw-bold me-2" style="margin-bottom: 0px;color: #605D62;">  > </p>
            <p class="fw-bold" style="color: #6c6a6a;margin-bottom: 0px;"routerLink="/checkout-inquire"> view booking details </p>


        </div>

    </div>
    <div class="card shadow-sm px-4">
      <div class="title ">
        <h4>view booking details</h4>
        <p-button
            label="Share Via Email"
            icon="pi pi-share-alt"
            class="p-button-outlined custom-button"
            ></p-button>

      </div>
      <!-- <div style="margin-bottom: 20px;   height: 1px; background: #EBEBEB"></div> -->
      <div class="bg-white rounded-3 py-3 ">
        <div class=" ">

            <div class="d-flex mb-5 d-md-block d-flex justify-content-center justify-md-content-start ">
                <div style="justify-content: center;" class=" d-md-flex  align-items-center justify-md-content-start ">
                    <div class="rounded-circle imageOfPerson me-4" style="box-shadow: 0 2px 6px #d1d1d1;">
                        <img class="imageOfPerson rounded-circle" style="border: 3px solid white;"  [src]="CheckoutSheet.guest_Image">
                    </div>

                    <div class="d-flex mt-4">
                        <div class="d-flex  justify-content-between ">


                            <!-- <button type="button" class="outline-none border-0 py-2 px-3 rounded-3 delete" *ngIf="titlePage!='Owner details'" (click)="uploadPic('delete')">Delete</button> -->
                            <!-- <button class="me-3 outline-none border-0 text-white py-2 px-3 rounded-3" *ngIf="titlePage=='Owner details'" style="background-color: #1f4068;">Message</button> -->
                        </div>
                    </div>
                </div>
                <div  class="text-center">

                    <h4>{{ CheckoutSheet.guest_Name }}</h4>
                    <p>{{ CheckoutSheet.guest_Mail }}</p>
                  </div>

            </div>
            <!--start General info form-->
            <!-- <form> -->
            <p-toast></p-toast>
            <div class="row">
                <div class="classheadper">
                    <div class="caslshead2per">
                        <div class="classper22deatil">
                            <div class="bookind">Booking ID</div>
                        </div>
                        <div class="bookingIdss">{{ CheckoutSheet.booking_Code }}</div>
                    </div>
                    <div class="checkinnn"></div>
                    <div   class="checkindate">
                        <div class="classper22deatil">
                            <div class="checkindate22">
                                <div  class="imgcheckin"> <img src="../../../../assets/images/uiw_date.svg"> </div>
                            </div>
                            <div     class="imgcheckinndate">contract start date </div>
                        </div>
                        <div style="width: 139px; height: 20px; color: #787579; font-size: 16px; font-family: popines; font-weight: 400; line-height: 20px; word-wrap: break-word">{{ CheckoutSheet.contract_Start_Date | date: 'mediumDate' }}</div>
                    </div>
                    <div class="checkinnn"></div>
                    <div  class="checkindate">
                        <div class="classper22deatil">
                            <div class="checkindate22">
                                <div class="imgcheckin"><img src="../../../../assets/images/uiw_date.svg"></div>
                            </div>
                            <div   class="imgcheckinndate">contract end date</div>
                        </div>
                        <div style="width: 139px; height: 20px; color: #787579; font-size: 14px; font-family: popines; font-weight: 500; text-transform: capitalize; line-height: 20px; word-wrap: break-word">{{ CheckoutSheet.contract_End_Date | date: 'mediumDate' }}</div>
                    </div>
                    <div class="checkinnn" *ngIf=" CheckoutSheet.extended_To!='0001-01-01T00:00:00'"></div>
                    <div  class="checkindate" *ngIf=" CheckoutSheet.extended_To!='0001-01-01T00:00:00'">
                        <div class="classper22deatil">
                            <div class="checkindate22">
                                <div class="imgcheckin"><img src="../../../../assets/images/uiw_date.svg"></div>
                            </div>
                            <div   class="imgcheckinndate">Extended To</div>
                        </div>
                        <div style="width: 139px; height: 20px; color: #787579; font-size: 14px; font-family: popines; font-weight: 500; text-transform: capitalize; line-height: 20px; word-wrap: break-word">{{ CheckoutSheet.extended_To | date: 'mediumDate' }}</div>
                    </div>
                    <div class="checkinnn"></div>
                    <div  class="checkindate">
                        <div class="classper22deatil">
                            <div class="checkindate22">
                                <div class="imgcheckin"><img src="../../../../assets/images/uiw_date.svg"></div>
                            </div>
                            <div   class="imgcheckinndate">check out date</div>
                        </div>
                        <div style="width: 139px; height: 20px; color: #787579; font-size: 14px; font-family: popines; font-weight: 500; text-transform: capitalize; line-height: 20px; word-wrap: break-word">{{ CheckoutSheet.checkout_Date | date: 'mediumDate' }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px;margin-bottom: 20px;   height: 1px; background: #EBEBEB"></div>

  <p></p>


  <div class="card-header">
    <h4 class="fs-6 fw-bold">Rooms Details</h4>
  </div>

  <div class="row">
    <div class="col-12 mb-3">
      <div class="d-flex justify-content-between px-4">
        <div class="">
            <div class="mb-3">Bed No</div>
            <div class="fw-semibold">{{ CheckoutSheet.bed_No }}</div>

        </div>

        <div>
            <div class="mb-3">Room type</div>
            <div class="fw-semibold">{{ CheckoutSheet.bed_Type }}</div>
        </div>

      <div>
        <div class="mb-3">Bed price</div>
        <div class="fw-semibold">€{{ CheckoutSheet.bed_Price }}</div>
      </div>


       <div>
        <div class="mb-3">Security deposit</div>
        <div class="fw-semibold">€{{ CheckoutSheet.secuirty_Deposit }}</div>
       </div>


        <div>
            <div class="mb-3">Service fee</div>
            <div class="fw-semibold">€{{ CheckoutSheet.service_Fee }}</div>
        </div>


        <!-- <div class="fw-bold">Status</div> -->
      </div>
    </div>
  </div>

    <!-- <div class="row">
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between px-4">
          <div class="fw-semibold">Bed 1</div>
          <div class="fw-semibold">Single Room</div>
          <div class="fw-semibold">€500</div>
          <div class="fw-semibold">€100</div>
          <div class="fw-semibold">€100</div>

        </div>
      </div>
    </div> -->




    <div class="tenant-documents m-0 mb-3">

      <div class="header">
        <!-- <h3>{{upcome.bed_Name}}</h3>
        <hr /> -->
        <h3>Tenant Documents</h3>
        <p>View tenant Documents</p>
      </div>
      <div class="documents-container row">
        <div class="col-md-6">
          <div class="document-header">QR Details</div>
          <div class="document-content">
            <div class="doc-info">
              <p>Qr Code:{{ CheckoutSheet.qR_Code }}</p>
            </div>
            <div class="doc-actions">
              <button class="btn-view"
                (click)="onOpenQrModal ()"><i
                  class="pi pi-eye"></i> View</button>
              <!-- <button class="btn-download capture"
              (click)="downloadAsPDF()"><i
                  class="pi pi-download"></i> Download</button> -->
              <!-- <p>{{bed.bed_QR_Img}}</p> -->
              <!-- <button class="btn-share"><i class="pi pi-share"></i> Share</button> -->
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="document-header">Contract</div>
          <div class="document-content">
            <div class="doc-info">
              <img src="assets/images/document.svg" alt="Contract" />
              <p>Contract.pdf</p>
            </div>
            <div class="doc-actions">
              <a class="text-decoration-none" href="{{ CheckoutSheet.contract || '##' }}" target="_blank">
                <button class="btn-view">
                  <i class="pi pi-eye"></i> View
                </button>
              </a>
              <a class="text-decoration-none" href="{{ CheckoutSheet.contract || '##'}}" download>
                <button class="btn-download">
                  <i class="pi pi-download"></i> Download
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="document-header">Handover protocols</div>
          <div class="document-content">
            <div class="doc-info">
              <img src="assets/images/document.svg" alt="Handover protocols" />
              <p>Handover protocols.pdf</p>
            </div>
            <div class="doc-actions">
              <a class="text-decoration-none" href="{{ CheckoutSheet.handover|| '##' }}" target="_blank">
                <button class="btn-view">
                  <i class="pi pi-eye"></i> View
                </button>
              </a>
              <a class="text-decoration-none" href="{{ CheckoutSheet.handover || '##'}}" download>
                <button class="btn-download">
                  <i class="pi pi-download"></i> Download
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="document-header">Rental Rules</div>
          <div class="document-content">
            <!-- <div class="doc-info">
          <p>Qr Code:{{ room.room_QRCode }}</p>
        </div>
        <div class="doc-actions">
          <button class="btn-view" (click)="onOpenQrModal(room.room_QR_Img)"><i class="pi pi-eye"></i> View</button>
          <button class="btn-download"><i class="pi pi-download"></i> Download</button>
        </div> -->
            <div class="doc-info">
              <img src="assets/images/document.svg" alt="Handover protocols" />
              <p>Rental Rules.pdf</p>
            </div>
            <div class="doc-actions">
              <a class="text-decoration-none" [href]="CheckoutSheet.rental_Rules || '#'">
                <button class="btn-view" [disabled]="!CheckoutSheet.rental_Rules">
                  <i class="pi pi-eye"></i> View
                </button>
              </a>
              <a class="text-decoration-none" [href]="CheckoutSheet.rental_Rules || '#'" download>
                <button class="btn-download" [disabled]="!CheckoutSheet.rental_Rules">
                  <i class="pi pi-download"></i> Download
                </button>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>>



  <div class="row bg-white m-0 p-4" id="more-details">
    <div class="col-12 m-0 p-3 rounded pl-4 pr-4">
      <div class="row align-items-center">
        <div class="container mt-3">
          <h6 class="fw-bold text-lowercase">More details</h6>
          <p class="text-muted">View tenant passport,
            invoices and problems</p>


            <p-accordion [multiple]="true"  >
              <p-accordionTab header="Passport of tenent">
                <div class="flex-container">

                  <img   [src]="CheckoutSheet.passport_Image" style="width: 400px; height: 400px; display: block;" />

                </div>


              </p-accordionTab>
               <!-- Pending Problems -->
  <!-- Pending Problems Table -->
  <p-accordionTab header="Problem reports ({{ pendingProblems.length }})">
    <p-table
      *ngIf="pendingProblems.length > 0; else noPendingProblems"
      [value]="pendingProblems"
      [tableStyle]="{ 'min-width': '0px !important' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Problem Code</th>
          <th>Apartment Name</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-problem>
        <tr>
          <td>{{ problem.problem_Code }}</td>
          <td>{{ problem.apartment_Name }}</td>
          <td>{{ problem.problem_Status }}</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template #noPendingProblems>
      <p>No pending problems.</p>
    </ng-template>
  </p-accordionTab>

  <!-- Fixed Problems Table -->
  <p-accordionTab header="Fixed problems ({{ fixedProblems.length }})">
    <p-table
      *ngIf="fixedProblems.length > 0; else noFixedProblems"
      [value]="fixedProblems"
      [tableStyle]="{ 'min-width': '0px !important' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Problem Code</th>
          <th>Apartment Name</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-problem>
        <tr>
          <td>{{ problem.problem_Code }}</td>
          <td>{{ problem.apartment_Name }}</td>
          <td>{{ problem.problem_Status }}</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template #noFixedProblems>
      <p>No fixed problems.</p>
    </ng-template>
  </p-accordionTab>
              <p-accordionTab header="Invoices">
                <p-table
                class="more-d"
                [columns]="cols"
                [value]="CheckoutSheet.invoices"
                [tableStyle]="{ 'min-width': '0px !important' }">
                <!-- Table Header -->
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns">
                      {{ col.header }}
                    </th>
                  </tr>
                </ng-template>

                <!-- Table Body -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns">
                      <!-- Conditional Rendering for Payment Status -->
                      <span *ngIf="col.field === 'payment_Is_Paid'">
                        {{ rowData[col.field] ? 'Yes' : 'No' }}
                      </span>

                      <!-- Date Formatting for Invoice Date -->
                      <span *ngIf="col.field === 'invoice_Date'">
                        {{ rowData[col.field] | date: 'mediumDate' }}
                      </span>
                        <!-- Duration Formatting -->
                      <span *ngIf="col.field === 'invoice_Duration'">
                        {{ rowData[col.field].split(' - ')[0] | date: 'mediumDate' }} -
                        {{ rowData[col.field].split(' - ')[1] | date: 'mediumDate' }}
                      </span>

                      <!-- Regular Rendering for Other Fields -->
                      <span *ngIf="col.field !== 'payment_Is_Paid' && col.field !== 'invoice_Date' && col.field !== 'invoice_Duration'">
                        {{ rowData[col.field] }}
                      </span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>


              </p-accordionTab>

          </p-accordion>

        </div>
      </div>
    </div>
  </div>























  </div>










  <div *ngIf="qrImg !== ''" class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': displayQr}"
  style="background-color: rgb(23 22 22 / 50%);">
  <div class="modal-dialog" role="document" style="max-width: 371px;">
    <div class="modal-content" style="margin-top: 150px;">
      <button  type="button" aria-label="Close"
        style="border: none; background-color: #ffffff; width:40px; height: 40px;margin-left: auto;margin-right:15px;">
        <button aria-hidden="true" style="color: #000000; font-size: 35px; border: none; background-color: #ffffff;" (click)="onCloseQrModal()">×</button>
      </button>
      <div class="modal-body">
        <div class="row text-center justify-content-center " #qrToPdf id="qrToPdf">


          <div class="d-flex justify-content-between fs-6 fw-bold">
            <!-- <div class="mr-3">{{roomType}}.R<div>R/{{roomNo}}</div></div> -->
            <div class="mr-3">{{roomType}}.R </div>

            <div style="width:170px"></div>
            <div>ID-{{CheckoutSheet?.qR_Code}} </div>
          </div>
          <p class="mt-4 fs-6 text-center">Scan this code</p>
          <img id="qr_image_e" [src]="qrImg" class="qrfix">
          <div class="fw-bold text-center fs-6 mt-4">QR Code : <span class="fw-normal" style="color:#B3261E;">{{CheckoutSheet?.qR_Code}}</span> </div>

        </div>
        <div class="row text-center justify-content-center">
          <p class="mt-4 text-center">Or enter the number manually</p>
          <div class="custom-apartment-buttons mt-1" >
            <button class="custom-btn-delete">{{CheckoutSheet?.qR_Code}}</button>
            <button class="custom-btn-rented mt-4" (click)="printDiv('qrToPdf')">Download</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
